export * from "./jira-product-discovery.template";
export { JiraProductDiscoveryTemplate as default } from "./jira-product-discovery.template";
